<div class="row">
    <div class="col-lg-12">
        <ol class="breadcrumb">
            <li><a href="javascript:void(0)" (click)="$state.go('missioncontrol.dashboard', {}, {reload: true})">Home</a></li>
            <li class="active"><span>Candidate Workflow</span></li>
        </ol>
        <div class="workflow-header">
            <h1 id="candidateWorkflowTitle" class="heading-css cursor-default" style="margin-bottom: 0px; font-size:24px;">
                Candidate Workflow
                <span>
                    <span class="mr-2">for</span>
                    <span *ngIf="!jobInfoLoadedFlag" class="skeleton-container d-inline-block align-middle" style="width:200px;">
                        <span class="skeleton-heading skeleton-loading my-0 d-inline-block" style="width:100%;"></span>
                    </span>
                    <span *ngIf="jobInfoLoadedFlag" class="badge text-overflow-ellipsis" style="font-size: 0.8em;margin-bottom:5px;max-width: 800px;" [ngClass]="{'badge-primary': !jobInfo.sharedRequisition, 'workflow-shared-requisition-badge': jobInfo.sharedRequisition}">
                        <span class="cursor-pointer" (click)="performActionMultiple('jobProfile')">
                            {{jobInfo.requisitionRole}}
                        </span>
                        <app-info-icon *ngIf="jobInfo.requisitionNote" style="position:relative;bottom:1px;font-size:13px;"
                            [info]="jobInfo.requisitionNote"
                            [infoTitle]="'Requisition Info'"
                            [iconClass]="'text-white'">
                        </app-info-icon>
                        <span *ngIf="jobInfo.requisitionActualNumber != null">({{jobInfo.requisitionActualNumber}})</span>
                        <span [tooltip]="headerInfo" placement="top" container="body" [adaptivePosition]="false">{{companyLabel}}</span>
                        <app-info-icon *ngIf="jobInfo.clientNote" style="position:relative;bottom:1px;font-size:13px;"
                            [info]="jobInfo.clientNote"
                            [infoTitle]="'Info'"
                            [iconClass]="'text-white'">
                        </app-info-icon>
                        <span [tooltip]="headerInfo" placement="top" container="body" [adaptivePosition]="false">{{locationLabel}}</span>
                    </span>
                    <span *ngIf="jobInfoLoadedFlag" tooltip="Job Type" placement="top" container="body" [adaptivePosition]="false" class="badge cursor-default mx-2" style="font-size: 0.8em;margin-bottom:5px;" [ngClass]="{'badge-primary': !jobInfo.sharedRequisition, 'workflow-shared-requisition-badge': jobInfo.sharedRequisition}">
                        {{jobInfo.jobType}} <span *ngIf="jobInfo.contractDuration">({{jobInfo.contractDuration}} months)</span>
                    </span>
                    <span *ngIf="jobInfoLoadedFlag && isStaffingFlag && !jobInfo.sharedRequisition && endClient" tooltip="End Client - {{endClient}}" placement="top" container="body" [adaptivePosition]="false" class="badge cursor-default" style="font-size: 0.8em;margin-bottom:5px;" [ngClass]="{'badge-primary': !jobInfo.sharedRequisition, 'workflow-shared-requisition-badge': jobInfo.sharedRequisition}">
                        {{endClient.length > 20 ? (endClient.slice(0,20) + "...") : endClient}}
                    </span>
                    <span *ngIf="jobMatchInProgress" class="pl-1 position-relative job-macth-in-progress-workflow skeleton-container d-inline-block align-middle"
                        tooltip="Job Matching for all candidates in progress" placement="top" container="body" [adaptivePosition]="false" style="width:16px;">
                        <span class="skeleton-heading skeleton-loading my-0 d-inline-block" style="width:100%;"></span>
                    </span>
                </span>
            </h1>
        </div>
        <div class="work-flow-req-details-container">
            <span *ngIf="!jobInfoLoadedFlag" class="skeleton-container d-inline-block align-middle" style="width:150px;">
                <span class="skeleton-heading skeleton-loading my-0 d-inline-block" style="width:100%;"></span>
            </span>
            <div class="workflow-openings-icons-container">
                <span class="text-left req-company-name workflow-openings-icon mr-2" *ngIf="jobInfoLoadedFlag" id="details-tooltip-color" tooltip="Total Openings">
                    <i class="fas fa-door-open" [ngClass]="{'workflow-shared-requisition-openings': jobInfo.sharedRequisition, 'emerald': !jobInfo.sharedRequisition }"></i>
                    <span>{{jobInfo.requisitionOpeningsCount?.noOfOpenings}}</span>
                </span>
                <span class="text-left req-company-name workflow-openings-icon" *ngIf="jobInfoLoadedFlag" id="details-tooltip-color" tooltip="Filled">
                    <i class="fas fa-user-check" [ngClass]="{'workflow-shared-requisition-openings': jobInfo.sharedRequisition, 'emerald': !jobInfo.sharedRequisition }"></i>
                    <span>{{jobInfo.requisitionOpeningsCount?.noOfFilled}}</span>
                </span>
                <span class="text-left req-company-name workflow-openings-icon" *ngIf="jobInfoLoadedFlag" id="details-tooltip-color" tooltip="Joined">
                    <i class="far fa-handshake" [ngClass]="{'workflow-shared-requisition-openings': jobInfo.sharedRequisition, 'emerald': !jobInfo.sharedRequisition }"></i>
                    <span>{{jobInfo.requisitionOpeningsCount?.noOfJoined}}</span>
                </span>
            </div>
            <span *ngIf="jobInfoLoadedFlag" class="badge cursor-default mr-2" style="line-height:inherit; font-size:0.95em" [ngClass]="{'badge-primary': !jobInfo.sharedRequisition, 'workflow-shared-requisition-badge': jobInfo.sharedRequisition}" tooltip="Requisition Status" placement="bottom">
                <span class="text-left">{{jobInfo.requisitionStatus}}</span>
            </span>
            <span *ngIf="isStaffingFlag && pointOfContact != null" class="badge cursor-default mr-2" style="line-height:inherit; font-size:0.95em" tooltip="Point of Contact" placement="bottom"
                [ngClass]="{'badge-primary': isCorporateFlag, 'workflow-shared-requisition-badge': !isCorporateFlag}">
                <div class="text-left text-overflow-ellipsis" style="max-width: 200px">{{pointOfContact}}</div>
            </span>
            <span *ngIf="jobInfoLoadedFlag && primaryHiringManager.length > 0 && isCorporateFlag">
                <span class="badge cursor-default badge-primary mr-2" tooltip="Hiring Managers" placement="bottom" style="line-height:inherit; font-size:0.95em">
                    <div class="text-left">
                        <span [tooltip]="primaryHiringManager[0].name" container="body">
                            {{primaryHiringManager[0].name.length > 25 ? (primaryHiringManager[0].name.slice(0,25)+"...") : primaryHiringManager[0].name}}
                        </span>
                        <span class="candidate-work-flow-primary-hiring-manager-icon mr-1" style="font-family: cursive; font-size: 14px;"
                            *ngIf="primaryHiringManager[0].isPrimary" tooltip="Primary Hiring Manager" container="body">P</span>
                        <span class="fas fa-user-tie candidate-work-flow-primary-hiring-manager-icon mr-1"
                            *ngIf="primaryHiringManager[0].isPoc" tooltip="Point of contact" container="body">
                        </span>
                    </div>
                </span>
                <span *ngIf="hiringManagersList.length > 0" class="badge cursor-pointer candidate-workflow-superscript mr-2"
                    [ngClass]="{'badge-primary': isCorporateFlag || (!isCorporateFlag && jobInfo.sharedRequisition), 'workflow-shared-requisition-badge': !isCorporateFlag && !jobInfo.sharedRequisition}"
                    (click)="isHiringManagerPopoverOpen = !isHiringManagerPopoverOpen"
                    placement="auto" containerClass="requisition-card-hiring-managers-popover"
                    [popover]="hiringManagersPopoverTemplate" [outsideClick]="true" triggers="click:mouseleave">
                    <div class="text-left text-overflow-ellipsis" style="max-width: 200px">+{{hiringManagersList.length}}</div>
                </span>
            </span>
            <span *ngIf="jobInfoLoadedFlag && jobInfo.pocRecruiter">
                <span class="badge cursor-default badge-primary mr-2" tooltip="Recruiters" placement="bottom" style="line-height:inherit; font-size:0.95em">
                    <div class="text-left">
                        <span [tooltip]="jobInfo.pocRecruiter.name" container="body">
                            {{jobInfo.pocRecruiter.name.length > 25 ? (jobInfo.pocRecruiter.name.slice(0, 25) + "...") : jobInfo.pocRecruiter.name}}
                        </span>
                        <span class="fas fa-user-tie candidate-work-flow-primary-hiring-manager-icon mr-1" *ngIf="jobInfo.pocRecruiter.isPoc"
                            tooltip="Point of contact" container="body">
                        </span>
                    </div>
                </span>
                <span *ngIf="jobInfo.recruitersCount > 0" class="badge cursor-pointer candidate-workflow-superscript badge-primary mr-2"
                    (click)="isRecruitersPopoverOpen = !isRecruitersPopoverOpen"
                    placement="auto" containerClass="requisition-card-hiring-managers-popover"
                    [popover]="recruitersPopoverTemplate" [outsideClick]="true" triggers="click">
                    <div class="text-left text-overflow-ellipsis" style="max-width: 200px">+{{jobInfo.recruitersCount}}</div>
                </span>
            </span>
            <span *ngIf="jobInfoLoadedFlag" class="badge cursor-pointer position-relative mr-2" style="line-height:inherit" [ngClass]="{'badge-primary': !jobInfo.sharedRequisition, 'workflow-shared-requisition-badge': jobInfo.sharedRequisition}">
                <i class="fas fa-dollar-sign" *ngIf="jobInfo.requisitionSalaryDisplayMessage != 'Not Available'"
                    containerClass="additional-details-pop-over candidate-job-match-card-popover"
                    placement="bottom" [popoverTitle]="jobInfo.salaryLabel" [popover]="jobMatchSalaryTemplate" triggers="mouseenter:mouseleave">
                </i>
                <i *ngIf="jobInfo.requisitionSalaryDisplayMessage == 'Not Available'" class="fas fa-dollar-sign"
                    tooltip="Job Salary not available" container="body"></i>
                <span *ngIf="jobInfo.requisitionSalaryDisplayMessage == 'Not Available'"
                    class="fa fa-times red candidate-job-match-card-not-available-icon" style="left:11px;"></span>
            </span>
            <span *ngIf="jobInfoLoadedFlag" class="badge cursor-pointer position-relative mr-2" style="line-height:inherit; font-size:0.95em" [ngClass]="{'badge-primary': !jobInfo.sharedRequisition, 'workflow-shared-requisition-badge': jobInfo.sharedRequisition}">
                <i class="fas fa-award" *ngIf="jobInfo.sponsorships && jobInfo.sponsorships.length > 0"
                    containerClass="additional-details-pop-over candidate-job-match-card-popover"
                    placement="bottom" popoverTitle="Sponsorships" [popover]="jobMatchSponsorshipsTemplate" triggers="mouseenter:mouseleave">
                </i>
                <i *ngIf="!jobInfo.sponsorships || jobInfo.sponsorships.length == 0" class="fas fa-award"
                    tooltip="Job Sponsorships not available" container="body"></i>
                <span *ngIf="!jobInfo.sponsorships || jobInfo.sponsorships.length == 0"
                    class="fa fa-times red candidate-job-match-card-not-available-icon" style="left: 13.5px"></span>
            </span>
            <span style="padding-left: 5px; padding-right: 9px;" *ngIf="isTechAssessmentInfoExists || jobInfoLoadedFlag" class="badge cursor-pointer candidate-job-match-assessment-icons mr-2"
                [ngClass]="{'badge-primary': !jobInfo.sharedRequisition, 'workflow-shared-requisition-badge': jobInfo.sharedRequisition}">
                <i class="candidate-job-match-tech-assessment-icon"
                    containerClass="candidate-assessment-details-pop-over"
                    placement="auto bottom" popoverTitle="Technical Assessment Details" [popover]="techAssessmentInfoTemplate" triggers="mouseenter:mouseleave"
                    (mouseover)="_getAssessmentDetails()">T
                </i>
            </span>
            <span class="badge cursor-pointer mr-2" style="line-height:inherit; font-size:0.95em"
                *ngIf="jobInfoLoadedFlag && isCorporateFlag && jobInfo.sharedRequisition && jobInfo.vendorsDetails"
                [ngClass]="{'badge-primary': !jobInfo.sharedRequisition, 'workflow-shared-requisition-badge': jobInfo.sharedRequisition}">
                <i class="fas fa-network-wired" containerClass="additional-details-pop-over" placement="auto bottom" popoverTitle="Vendors" [popover]="vendorsTemplate" triggers="mouseenter:mouseleave"></i>
            </span>
            <span class="badge cursor-pointer candidate-job-match-assessment-icons mr-2" *ngIf="isValueAssessmentInfoExists && jobInfoLoadedFlag"
                [ngClass]="{'badge-primary': !jobInfo.sharedRequisition, 'workflow-shared-requisition-badge': jobInfo.sharedRequisition}">
                <i class="fab fa-vimeo-v" containerClass="candidate-assessment-details-pop-over" placement="auto bottom" popoverTitle="Value Assessment Details"
                    [popover]="valueAssessmentInfoTemplate" triggers="mouseenter:mouseleave" (mouseover)="_getValueAssessmentDetails()">
                </i>
            </span>
            <span *ngIf="jobInfoLoadedFlag" class="badge cursor-pointer position-relative mr-2" style="line-height:inherit; font-size:0.95em" [ngClass]="{'badge-primary': !jobInfo.sharedRequisition, 'workflow-shared-requisition-badge': jobInfo.sharedRequisition}">
                <i class="far fa-building" *ngIf="jobInfo.workLocations && jobInfo.workLocations.length > 0"
                    containerClass="additional-details-pop-over candidate-job-match-card-popover" placement="bottom" popoverTitle="Work Locations" [popover]="jobWorkLocationsTemplate" triggers="mouseenter:mouseleave">
                </i>
                <i *ngIf="!jobInfo.workLocations || jobInfo.workLocations.length == 0" class="far fa-building" tooltip="Job Work locations not available" container="body"></i>
                <span *ngIf="!jobInfo.workLocations || jobInfo.workLocations.length == 0" class="fa fa-times red candidate-job-match-card-not-available-icon" style="left: 14px"></span>
            </span>
            <span *ngIf="jobInfoLoadedFlag && (!jobInfo.autoMatedMatchEnabled || !jobInfo.autoMatedMatchSelected)"
                class="badge cursor-pointer px-2 mr-2" style="line-height:inherit; font-size:0.95em" tooltip="Manual Matching" container="body"
                [ngClass]="{'badge-primary': !jobInfo.sharedRequisition, 'workflow-shared-requisition-badge': jobInfo.sharedRequisition}">
                <i class="fas fa-hand-paper"></i>
            </span>
            <span *ngIf="jobInfoLoadedFlag && jobInfo.autoMatedMatchEnabled && jobInfo.autoMatedMatchSelected"
                class="badge cursor-pointer mr-2" style="line-height:inherit; font-size:0.95em" tooltip="Automated Candidate Matching" container="body"
                [ngClass]="{'badge-primary': !jobInfo.sharedRequisition, 'workflow-shared-requisition-badge': jobInfo.sharedRequisition}">
                <i class="fa fa-cogs fa-sm"></i>
            </span>
            <span *ngIf="jobInfoLoadedFlag && reqStateData" class="badge cursor-pointer mr-2" style="line-height:inherit; font-size:0.95em" [ngClass]="{'badge-primary': !jobInfo.sharedRequisition, 'workflow-shared-requisition-badge': jobInfo.sharedRequisition}" [tooltip]="reqStateData.reqStateMessage" placement="bottom">
                <div class="text-left text-overflow-ellipsis" style="max-width: 200px">
                    <span *ngIf="reqStateData.reqStateData == 0">Today</span>
                    <span *ngIf="reqStateData.reqStateData > 0">
                        {{reqStateData.reqStateData}}
                        <span *ngIf="reqStateData.reqStateData == 1"> day</span>
                        <span *ngIf="reqStateData.reqStateData > 1"> days</span>
                    </span>
                </div>
            </span>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-xs-12">
        <div style="margin:10px;margin-top:20px;font-size:0.9em" class="pull-left">
            <div style="padding-right:10px;" class="pull-left">
                <input type="checkbox" id="assignedToMeFilter" name="assignedToMeFilter"
                    [(ngModel)]="globalQueryFilterObject.isAssignedToMe" (click)="onGlobalFilterChange()">
                <label for="assignedToMeFilter"><strong>Assigned To Me</strong></label>
            </div>
            <div style="padding-right:10px;" class="pull-left">
                <input type="checkbox" id="assignedToOthers" name="assignedToOthers"
                    [(ngModel)]="globalQueryFilterObject.isAssignedToOthers" (click)="onGlobalFilterChange()">
                <label for="assignedToOthers"><strong>Assigned To Others</strong></label>
            </div>
            <div class="pull-left">
                <input type="checkbox" id="unassignedFilter" name="unassignedFilter"
                    [(ngModel)]="globalQueryFilterObject.isUnassigned" (click)="onGlobalFilterChange()">
                <label for="unassignedFilter"><strong>Unassigned</strong></label>
            </div>
        </div>
        <div style="margin: 10px;" class="pull-right">
            <span title="Click to show / hide the filter" class="pull-right filter-icon">
                <i class="fa fa-filter fa-2x cursor-point" aria-hidden="true" id="open-filter"></i>
            </span>
        </div>
        <div style="margin: 10px;" class="pull-right" [hidden]="hideSearchStringFlag">
            <input id="candidateJobMatchesWorkflowSearchText" class="text-center filter-style inputBoxBorder" type="text"
                placeholder="Search" [(ngModel)]="globalQueryFilterObject.searchString" (keyup)="onGlobalFilterChange($event)" (ngModelChange)="addToDisplayFilters('search')" />
        </div>
        <div class="btn-group dropdown pull-right" id="candidate-job-matches-actions" style="margin: 10px;">
            <button type="button" class="btn btn-primary" data-toggle="dropdown">Actions</button>
            <button type="button" class="btn btn-primary" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <span class="caret"></span> <span class="sr-only"></span>
            </button>
            <ul class="dropdown-menu" role="menu" [ngClass]="{'pb-0': isSuperUserOr4dot5Admin}">
                <li role="menuitems">
                    <a href="javascript:void(0)" *ngIf="!disableAddActionsFlag" class="action-menu-item" (click)="performActionMultiple('addCandidates')">Add New Candidates</a>
                    <a href="javascript:void(0)" *ngIf="disableAddActionsFlag" style="opacity: 0.6;" [tooltip]="'This action is disabled as the requisition is in \'' + requisitionStatus + '\' status.'" class="action-menu-item" (click)="$event.stopPropagation()">Add New Candidates</a>
                </li>
                <li role="menuitems">
                    <a href="javascript:void(0)" *ngIf="!disableAddActionsFlag" class="action-menu-item" (click)="performActionMultiple('associateCandidates')">Associate Existing Candidates</a>
                    <a href="javascript:void(0)" *ngIf="disableAddActionsFlag" style="opacity: 0.6;" [tooltip]="'This action is disabled as the requisition is in \'' + requisitionStatus + '\' status.'" class="action-menu-item" (click)="$event.stopPropagation()">Associate Existing Candidates</a>
                </li>
                <li role="menuitems">
                    <a href="javascript:void(0)" class="action-menu-item" *ngIf="!disableAddActionsFlag && jobIntegrationEnabled" (click)="performActionMultiple('addCandidatesFromJobBoards')">Get Candidates from Job Boards</a>
                    <a href="javascript:void(0)" class="action-menu-item" *ngIf="!disableAddActionsFlag && !jobIntegrationEnabled" tooltip="Upgrade your plan to use this feature." (click)="$event.stopPropagation()">Get Candidates from Job Boards <span class="fa fa-2x fa-star gold"></span></a>
                    <a href="javascript:void(0)" *ngIf="disableAddActionsFlag" style="opacity: 0.6;" [tooltip]="'This action is disabled as the requisition is in \'' + requisitionStatus + '\' status.'" class="action-menu-item" (click)="$event.stopPropagation()">Get Candidates from Job Boards</a>
                </li>
                <li class="divider"></li>
                <li role="menuitems" *ngIf="isOutreachEnabled">
                    <a href="javascript:void(0)" class="action-menu-item" (click)="performActionMultiple('sendCandidateOutreach')">Send Candidate Outreach</a>
                </li>
                <li class="divider" *ngIf="isOutreachEnabled"></li>
                <li role="menuitems">
                    <a href="javascript:void(0)" class="action-menu-item" (click)="performActionMultiple('compareCandidates')">Compare Candidates</a>
                </li>
                <li class="divider" *ngIf="showGlobalAssignRecruiterAction"></li>
                <li role="menuitems" *ngIf="showGlobalAssignRecruiterAction">
                    <a href="javascript:void(0)" class="action-menu-item" (click)="performActionMultiple('assignRecruiter')" [ngClass]="{'workflow-disabled-global-action': disableAssignRecruiterActionsFlag}">Assign Recruiter</a>
                </li>
                <li class="divider" *ngIf="showGlobalTechAssessmentAction || showGlobalCancelTechAssessmentAction || showGlobalValueAssessmentAction || showGlobalCancelValueAssessmentAction"></li>
                <li role="menuitems" *ngIf="showGlobalTechAssessmentAction">
                    <a href="javascript:void(0)" class="action-menu-item" (click)="performActionMultiple('sendTechAssessment')" [ngClass]="{'workflow-disabled-global-action': disableSendTechAssessmentActionsFlag}">Send/Resend Tech Assessment</a>
                </li>
                <li role="menuitems" *ngIf="showGlobalValueAssessmentAction">
                    <a href="javascript:void(0)" class="action-menu-item" (click)="performActionMultiple('sendValueAssessment')" [ngClass]="{'workflow-disabled-global-action': disableValueAssessmentActionsFlag}">Send/Resend Value Assessment</a>
                </li>
                <li role="menuitems" *ngIf="showGlobalCancelTechAssessmentAction">
                    <a href="javascript:void(0)" class="action-menu-item" (click)="performActionMultiple('cancelTechAssessment')" [ngClass]="{'workflow-disabled-global-action': disableCancelTechAssessmentActionsFlag}">Cancel Tech Assessment</a>
                </li>
                <li role="menuitems" *ngIf="showGlobalCancelValueAssessmentAction">
                    <a href="javascript:void(0)" class="action-menu-item" (click)="performActionMultiple('cancelValueAssessment')" [ngClass]="{'workflow-disabled-global-action': disableCancelValueAssessmentActionsFlag}">Cancel Value Assessment</a>
                </li>
                <li class="divider"></li>
                <li role="menuitems">
                    <a href="javascript:void(0)" class="action-menu-item" (click)="performActionMultiple('release')" [ngClass]="{'workflow-disabled-global-action': disableReleaseCandidatesActionsFlag}">Release Candidates</a>
                </li>
                <li role="menuitems">
                    <a href="javascript:void(0)" class="action-menu-item" (click)="performActionMultiple('notInterested')" [ngClass]="{'workflow-disabled-global-action': disableMarkAsNotInterestedActionsFlag}">Mark as Not Interested</a>
                </li>
                <li role="menuitems" class="border-orange" *ngIf="isSuperUserOr4dot5Admin">
                    <a href="javascript:void(0)" class="action-menu-item" (click)="performActionMultiple('delete')">Delete Job Matches</a>
                </li>
            </ul>
        </div>
        <div class="pull-right">
            <button class="btn btn-primary mr-3" (click)="selectAllCandidates()"><span>Select All</span></button>
            <button class="btn btn-danger" (click)="deSelectAllCandidates()" style="margin:10px 0px"><span>Deselect All</span></button>
        </div>
    </div>
    <!--filter starts-->
    <div class="col-xs-12">
        <div class="row" style="position: relative;">
            <div class="col-xs-12" id="workflow-search-panel" style="display: none;">
                <div class="main-box" style="padding-top: 1%;">
                    <div class="main-box-body clearfix">
                        <form role="form" novalidate>
                            <div class="row">
                                <div class="col-lg-12 col-sm-12 col-md-12">
                                    <div class="row">
                                        <div class="col-sm-3 col-xs-12">
                                            <div class="form-group">
                                                <label for="jobMatchStates">Job Match States</label>
                                                <ng-select *ngIf="jobMatchStatesLoadedFlag" [items]="jobMatchStateOptions" bindLabel="label" groupBy="stepGroup"
                                                    [selectableGroup]="true" [selectableGroupAsModel]="false" placeholder="None selected"
                                                    [(ngModel)]="selectedJobMatchStates" [ngModelOptions]="{standalone: true}" [closeOnSelect]="false" [multiple]="true"
                                                    name="jobMatchStates" id="jobMatchStates" (change)="onFilterItemClick(null, 'JobMatchStates')">
                                                    <ng-template ng-header-tmp>
                                                        <div class="mr-2 custom-ng-select-btn" (click)="filterSelectRemoveAll('JobMatchStates', 'selectAll')">Select All</div>
                                                        <div class="custom-ng-select-btn" (click)="filterSelectRemoveAll('JobMatchStates', 'removeAll')">Select None</div>
                                                    </ng-template>
                                                    <ng-template ng-option-tmp let-item="item">
                                                        <span [innerHTML]="item.label"></span>
                                                    </ng-template>
                                                    <ng-template ng-multi-label-tmp let-items="items">
                                                        <span class="ng-value">{{ getMultiSelectSummary(items, 'label') }}</span>
                                                    </ng-template>
                                                </ng-select>
                                            </div>
                                        </div>
                                        <div class="col-sm-3 col-xs-12" *ngIf="showVendorFilterFlag">
                                            <div class="form-group">
                                                <label for="vendorsList">Vendors</label>
                                                <ng-select *ngIf="vendorsListLoadedFlag" [items]="vendorsList" bindLabel="vendorName" placeholder="None selected"
                                                    [(ngModel)]="selectedVendors" [ngModelOptions]="{standalone: true}" [closeOnSelect]="false" [multiple]="true"
                                                    name="vendorsList" id="vendorsList" (change)="onFilterItemClick(null, 'Vendors')">
                                                    <ng-template ng-header-tmp>
                                                        <div class="mr-2 custom-ng-select-btn" (click)="filterSelectRemoveAll('Vendors', 'selectAll')">Select All</div>
                                                        <div class="custom-ng-select-btn" (click)="filterSelectRemoveAll('Vendors', 'removeAll')">Select None</div>
                                                    </ng-template>
                                                    <ng-template ng-option-tmp let-item="item">
                                                        <span [innerHTML]="item.vendorName"></span>
                                                    </ng-template>
                                                    <ng-template ng-multi-label-tmp let-items="items">
                                                        <span class="ng-value">{{ getMultiSelectSummary(items, 'vendorName') }}</span>
                                                    </ng-template>
                                                </ng-select>
                                            </div>
                                        </div>
                                        <div class="col-sm-3 col-xs-12">
                                            <div class="form-group">
                                                <label for="outreachStates">Outreach States</label>
                                                <ng-select *ngIf="outreachFiltersLoadedFlag" [items]="outreachFilters" bindLabel="name" placeholder="None selected"
                                                    [(ngModel)]="selectedOutreachStates" [ngModelOptions]="{standalone: true}" [closeOnSelect]="false" [multiple]="true"
                                                    name="outreachStates" id="outreachStates" (change)="onFilterItemClick(null, 'OutreachStates')">
                                                    <ng-template ng-header-tmp>
                                                        <div class="mr-2 custom-ng-select-btn" (click)="filterSelectRemoveAll('OutreachStates', 'selectAll')">Select All</div>
                                                        <div class="custom-ng-select-btn" (click)="filterSelectRemoveAll('OutreachStates', 'removeAll')">Select None</div>
                                                    </ng-template>
                                                    <ng-template ng-option-tmp let-item="item">
                                                        <span [innerHTML]="item.name"></span>
                                                    </ng-template>
                                                    <ng-template ng-multi-label-tmp let-items="items">
                                                        <span class="ng-value">{{ getMultiSelectSummary(items, 'name') }}</span>
                                                    </ng-template>
                                                </ng-select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row pull-right">
                                <div class="col-lg-12 col-md-12 col-sm-12">
                                    <div class="form-group" id="resetFiltersButton" style="position:relative">
                                        <button type="button" class="btn btn-primary mr-2" [ngClass]="{'highlight-search-button': isFiltersChanged}" (click)="queryJobMatches()">Search</button>
                                        <button type="button" class="btn btn-danger" (click)="resetWorkflowFilters()">Reset</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--filter ends-->
</div>
<!-- Display Selected Filter Start -->
<div class="row mx-0" *ngIf="displayCandidateWorkFlowFilter">
    <div class="main-box">
        <div class="row my-3 pr-4 mr-1">
            <div class="col-xs-11">
                <div class="text-center pl-5" [hidden]="!candidatesObject.notInterestedInfo?.isFilterOn">
                    <span class="badge badge-primary px-3 py-2 ml-5">Filtered Results</span>
                </div>
            </div>
            <div class="col-xs-1">
                <div class="pull-right">
                    <span [hidden]="showDisplayFilterIcon" (click)="displaySelectedFilterToggle()"><i class="fas fa-plus cursor-pointer" style="font-size: 20px"></i></span>
                    <span [hidden]="!showDisplayFilterIcon" (click)="displaySelectedFilterToggle()"><i class="fas fa-minus cursor-pointer" style="font-size: 20px"></i></span>
                </div>
            </div>
        </div>
        <div id="display-candidate-workflow-selected-filter-panel" style="background-color: white; padding: 5px 20px;">
            <span *ngFor="let events of candidateWorkFlowFilterItemsSelected; let parentIndex = index">
                <span *ngIf="isFilterValueArray(events.value)">
                    <span *ngFor="let event of (events.value | slice:0:events.setSelectedFilterLimit); let i = index" class="pb-4 d-inline-block">
                        <span *ngIf="i == 0">
                            <span>( </span>
                            <span class="font-bold">{{events.variable}} = </span>
                        </span>
                        <span class="candidate-job-match-filter-chip-wrapper">
                            <span class="px-2 py-1 text-black rounded candidate-job-match-selected-filter">{{event}}</span>
                            <span class="position-absolute">
                                <i class="fas fa-times-circle text-danger position-relative cursor-pointer candidate-job-match-selected-filter-close-icon"
                                    (click)="deletedSelectedFilterItem(event)" style="font-size: 13px;"></i>
                            </span>
                        </span>
                        <span *ngIf="events.value.length !== 5 && i == 4 && !events.expandSelectedFilter"
                            class="py-1 text-black cursor-pointer"
                            (click)="events.setSelectedFilterLimit = events.value.length; events.expandSelectedFilter = true">
                            <span tooltip="Expand Filters" container="body" class="font-bold pl-2" style="color:#03a9f4;">...</span>
                        </span>
                        <span [hidden]="i == (events.value.length -1) || i == (events.setSelectedFilterLimit-1)" class="px-2">OR</span>
                        <span *ngIf="i == (events.value.length -1) || i == (events.setSelectedFilterLimit-1)">
                            <span>)</span>
                            <span [hidden]="parentIndex == (candidateWorkFlowFilterItemsSelected.length-1)"> AND</span>
                        </span>
                    </span>
                </span>
                <span *ngIf="!isFilterValueArray(events.value)" class="pb-4 d-inline-block">
                    <span>
                        <span>( </span>
                        <span class="font-bold">{{events.variable}} = </span>
                    </span>
                    <span class="candidate-job-match-filter-chip-wrapper">
                        <span class="px-2 py-1 text-black rounded candidate-job-match-selected-filter">{{events.value}}</span>
                        <span class="position-absolute">
                            <i class="fas fa-times-circle text-danger position-relative cursor-pointer candidate-job-match-selected-filter-close-icon"
                                (click)="deletedSelectedFilterItem(events.value)" style="font-size: 13px;"></i>
                        </span>
                    </span>
                    <span> )</span>
                    <span *ngIf="candidateWorkFlowFilterItemsSelected.length > 0">
                        <span [hidden]="parentIndex == (candidateWorkFlowFilterItemsSelected.length-1)"> AND</span>
                    </span>
                </span>
            </span>
            <span [hidden]="!(emptyJobMatchSelectedFilter && candidatesObject.notInterestedInfo?.isFilterOn)">No Filter Items Selected</span>
        </div>
    </div>
</div>
<!-- Display Selected Filter End -->
<div class="row row-horizon mt-4" id="steps-container" style="height:calc(100vh - 200px); outline-width:20px" cdkDropListGroup>
    <!-- active candidates columns -->
    <div *ngFor="let entry of candidatesObject | keyvalue: keepOriginalOrder" id="{{entry.value.uiIdentifier}}-candidates-column" class="col-xs-12 col-sm-6 col-md-4 col-lg-3 candidate-state-column"
        [ngClass]="{'candidate-state-column': !entry.value.isCollapsedFlag, 'candidate-state-column-collapse': entry.value.isCollapsedFlag}">
        <div class="main-box candidate-state-wrapper">
            <div class="candidate-state-wrapper-title">
                <div class="pull-left candidate-state-wrapper-title-name">{{entry.value.workflowStep}}</div>
                <div class="pull-right">
                    <span id="{{entry.value.uiIdentifier}}-candidates-column-toggle-icon" class="fa candidate-state-wrapper-collapse-icon"
                        [ngClass]="{'fa-chevron-left': entry.value.showCollapseIconFlag, 'fa-chevron-right': !entry.value.showCollapseIconFlag}"
                        (click)="toggleColumn(entry.value)" [tooltip]="entry.value.expandCollapseLabel"
                        container="body" [placement]="entry.value.countAndLabelTooltipPlacement">
                    </span>
                </div>
                <div class="pull-right">
                    <div class="candidate-state-wrapper-title-column-count" tooltip="Total number of workflow cards." [placement]="entry.value.countAndLabelTooltipPlacement" container="body">
                        {{entry.value.totalCandidateCount}}
                    </div>
                </div>
            </div>
            <div class="candidate-state-wrapper-column-container">
                <div class="candidate-state-wrapper-column" style="position:relative;height: calc(100vh - 280px); padding-right: 2px;overflow-y: auto;"
                    infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50" [scrollWindow]="false"
                    (scrolled)="entry.value.getNext()"
                    [infiniteScrollDisabled]="entry.value.busy || entry.value.disableInfiniteScroll">
                    <div class="candidate-state-wrapper-list">
                        <ul cdkDropList
                            [id]="entry.value.uiIdentifier"
                            [cdkDropListData]="entry.value.candidates"
                            [cdkDropListConnectedTo]="dropListIds"
                            [cdkDropListEnterPredicate]="canDropInStep(entry.value)"
                            (cdkDropListDropped)="onCdkDrop($event, entry.value)"
                            style="list-style: none outside none;">
                            <li *ngFor="let candidate of entry.value.candidates"
                                cdkDrag [cdkDragData]="candidate"
                                (cdkDragStarted)="onDragStart(candidate)"
                                (cdkDragEnded)="onDragEnd(candidate)"
                                class="draggable-card">
                                <app-candidate-job-match-card
                                    [candidateId]="candidate.id"
                                    [candidateJobMatch]="candidate"
                                    [jobMatchId]="candidate.jobMatchId"
                                    [context]="'workflow'"
                                    [jobWorkLocations]="jobInfo.workLocations"
                                    [jobLocation]="jobLocation"
                                    [disabledFlag]="candidate.disabledFlag"
                                    [activityMap]="activityMap"
                                    [salaryDurationOptions]="salaryDurationOptions"
                                    [jobTypeList]="jobTypeList"
                                    [allRecruitersAndHiringManagers]="jobInfo.listOfAllRecruitersAndHiringManagers"
                                    [assignedVendorDetails]="vendorsList"
                                    [isFirstStep]="entry.value.workflowStep === entry.value.workflowStepNames[0]"
                                    [workflowFirstStep]="workflowFirstStep"
                                    [isOutreachEnabled]="isOutreachEnabled"
                                    [resumeRequiredForWorkflow]="jobInfo.resumeRequiredForWorkflow"
                                    (saveCallback)="resetCandidateJobMatches()">
                                </app-candidate-job-match-card>
                            </li>
                        </ul>
                    </div>
                    <div [hidden]="!entry.value.busy" class="px-1">
                        <div *ngFor="let placeholder of skeletonPlaceholders" class="draggable-card">
                            <div class="candidate-job-match-card-container">
                                <div class="main-box clearfix profile-box-menu p-3 d-flex flex-column justify-content-between skeleton-container">
                                    <div class="d-flex flex-column skeleton-container mb-2">
                                        <div class="skeleton-heading width-75 skeleton-loading my-0 mb-2"></div>
                                        <div class="skeleton-paragraph width-50 skeleton-loading"></div>
                                    </div>
                                    <div class="d-flex justify-content-between skeleton-container mb-2">
                                        <div class="skeleton-paragraph width-25 skeleton-loading mb-2"></div>
                                        <div class="skeleton-paragraph width-25 skeleton-loading"></div>
                                    </div>
                                    <div class="d-flex justify-content-between skeleton-container mb-2">
                                        <div class="skeleton-paragraph width-25 skeleton-loading mb-2"></div>
                                        <div class="skeleton-paragraph width-25 skeleton-loading"></div>
                                    </div>
                                    <div class="d-flex justify-content-between align-items-center skeleton-container mb-2">
                                        <div class="skeleton-paragraph width-50 skeleton-loading"></div>
                                        <div class="skeleton-heading width-25 skeleton-loading my-0"></div>
                                    </div>
                                    <div class="d-flex justify-content-between align-items-center skeleton-container mb-3">
                                        <div class="skeleton-paragraph width-50 skeleton-loading"></div>
                                        <div class="skeleton-heading width-25 skeleton-loading my-0"></div>
                                    </div>
                                    <div class="d-flex flex-row justify-content-between skeleton-container">
                                        <div class="skeleton-paragraph width-25 skeleton-loading mb-2"></div>
                                        <div class="skeleton-paragraph width-25 skeleton-loading"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div [hidden]="entry.value.candidatesExistFlag || entry.value.isCollapsedFlag" class="no-workflow-cards-message">
                        <div class="text-center"><span>No workflow cards found.</span></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="workflow-refresh-message" *ngIf="showRefreshWorkFlowAction">
    <span class="workflow-refresh-step-change-count" *ngIf="!refreshReRunScore">{{countOfCandidatesWhoseStepHasChangedInBackground}}</span>
    <span>{{candidatesStepChangedInBackgroundMessage}}</span> <a class="emerald cursor-pointer" (click)="resetCandidateJobMatches()">REFRESH</a>
</div>

<ng-template #jobMatchSalaryTemplate>
    <p><span>{{jobInfo.requisitionSalaryDisplayMessage}}</span></p>
</ng-template>

<ng-template #jobMatchSponsorshipsTemplate>
    <p *ngIf="jobInfo.sponsorshipsDisplayMessage == 'Not Available' || jobInfo.sponsorshipsDisplayMessage == 'Sponsorship information not specified'">{{jobInfo.sponsorshipsDisplayMessage}}</p>
    <ng-container *ngIf="jobInfo.sponsorshipsDisplayMessage !== 'Not Available' && jobInfo.sponsorshipsDisplayMessage !== 'Sponsorship information not specified'">
        <p class="text-left" *ngFor="let sponsorship of jobInfo.sponsorships; let i = index">
            {{i + 1}}. {{sponsorship}}
        </p>
    </ng-container>
</ng-template>

<ng-template #jobWorkLocationsTemplate>
    <p *ngIf="jobInfo.workLocations == null"><span>Not Available</span></p>
    <p class="text-left" *ngFor="let workLocation of jobInfo.workLocations; let i = index">
        {{i + 1}}. {{workLocation.name}}
    </p>
</ng-template>

<ng-template #techAssessmentInfoTemplate>
    <div style="white-space: normal;">
        <div class="row">
            <div [hidden]="!techAssessmentInfoLoading" class="col-xs-12 requisition-card-loader-div skeleton-container">
                <div class="skeleton-heading width-75 skeleton-loading my-0 mb-2"></div>
                <div class="skeleton-paragraph width-50 skeleton-loading mb-2"></div>
                <div class="skeleton-paragraph width-100 skeleton-loading mb-2"></div>
                <div class="skeleton-paragraph width-100 skeleton-loading"></div>
            </div>
            <div class="col-xs-12" [hidden]="techAssessmentInfoLoading">
                <p class="mb-2">Assessment Details for <span class="pr-1">'<span class="emerald font-bold">{{assessmentDetails?.testAliasName}}</span>'.</span>
                    <span class="d-inline-block">Duration: {{assessmentDetails?.totalDuration}} minutes</span>
                </p>
                <p *ngIf="assessmentDetails?.techAssessmentThresholdScore">
                    <b>Threshold Score:</b> {{assessmentDetails.techAssessmentThresholdScore}}
                </p>
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th>Section Name</th>
                            <th>Section Type</th>
                            <th>Number of Questions</th>
                            <th>Duration</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let section of assessmentDetails?.sections">
                            <td>{{section.sectionName}}</td>
                            <td>{{section.sectionType}}</td>
                            <td>{{section.questions}}</td>
                            <td>{{section.duration}} minutes</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #valueAssessmentInfoTemplate>
    <div style="white-space: normal;">
        <div class="row">
            <div [hidden]="!valueAssessmentInfoLoading" class="col-xs-12 requisition-card-loader-div skeleton-container">
                <div class="skeleton-heading width-75 skeleton-loading my-0 mb-2"></div>
                <div class="skeleton-paragraph width-50 skeleton-loading mb-2"></div>
                <div class="skeleton-paragraph width-100 skeleton-loading mb-2"></div>
                <div class="skeleton-paragraph width-100 skeleton-loading"></div>
            </div>
            <div class="col-xs-12" [hidden]="valueAssessmentInfoLoading">
                <p>Assessment Details for <span class="pr-1">'<span class="emerald font-bold">{{valueAssessmentDetails?.testAliasName}}</span>'.</span>
                    <span class="d-inline-block">Duration: {{valueAssessmentDetails?.totalDuration}} minutes</span>
                </p>
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th>Section Name</th>
                            <th>Section Type</th>
                            <th>Number of Questions</th>
                            <th>Duration</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let section of valueAssessmentDetails?.sections">
                            <td>{{section.sectionName}}</td>
                            <td>{{section.sectionType}}</td>
                            <td>{{section.questions}}</td>
                            <td>{{section.duration}} minutes</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #recruitersPopoverTemplate>
    <div class="d-flex flex-wrap">
        <div class="text-center recruiter-item"
            [ngClass]="{'col-xs-12': jobInfo.recruiters?.length==1, 'col-xs-6': jobInfo.recruiters?.length<3, 'col-xs-3': jobInfo.recruiters?.length>=3}" style="flex-grow: 1;"
            *ngFor="let reqRecruiter of jobInfo.recruiters" [tooltip]="reqRecruiter.name" placement="bottom">
            <img src="assets/app-content/img/people/4dot5-default-no-profile-pic.jpg" [alt]="reqRecruiter.name" class="requisition-card-hiring-manager-img img-responsive" />
            <span class="requisition-card-hiring-manager-name">{{reqRecruiter.name}}</span>
        </div>
    </div>
</ng-template>

<ng-template #hiringManagersPopoverTemplate>
    <div class="d-flex flex-wrap">
        <div class="text-center recruiter-item"
            [ngClass]="{'col-xs-12': hiringManagersList.length==1, 'col-xs-6': hiringManagersList.length<3, 'col-xs-3': hiringManagersList.length>=3}" style="flex-grow: 1;"
            *ngFor="let hiringManager of hiringManagersList" [tooltip]="hiringManager.name" placement="bottom">
            <img src="assets/app-content/img/people/4dot5-default-no-profile-pic.jpg" [alt]="hiringManager.name" class="requisition-card-hiring-manager-img img-responsive" />
            <span class="requisition-card-hiring-manager-name">{{hiringManager.name}}</span>
        </div>
    </div>
</ng-template>

<ng-template #vendorsTemplate>
    <p *ngFor="let vendor of jobInfo.vendorsDetails">{{vendor.name}}</p>
</ng-template>
